import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$4 } from './button.js';
import { d as defineCustomElement$3 } from './icon.js';
import { d as defineCustomElement$2 } from './spinner.js';

const dropdownMenuButtonCss = ":host([aria-disabled=true]){cursor:no-drop;pointer-events:none}:host{font-family:var(--font-family-body, \"Inter\", sans-serif);width:100%}.menu-button.expanded.primary,.menu-button.expanded.secondary{--hmc-color-interactive-primary-idle:var(\n    --hmc-color-interactive-primary-hover\n  )}.menu-button.expanded.tertiary{--hmc-color-interactive-subtle-idle:var(\n    --hmc-color-interactive-subtle-hover\n  )}.menu-button.expanded.ghost{--button-ghost-bg:var(--hmc-color-interactive-silent-hover)}.menu-button.expanded.inverse.primary{--hmc-color-content-inverse:var(--hmc-color-interactive-silent-hover)}.menu-button.expanded.inverse.secondary,.menu-button.expanded.inverse.tertiary{--hmc-color-content-inverse:var(--hmc-color-interactive-silent-hover)}.menu-button.expanded.inverse.ghost{--button-ghost-bg:var(--hmc-color-content-default)}";

const HmcDropdownMenuButton$1 = /*@__PURE__*/ proxyCustomElement(class HmcDropdownMenuButton extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.toggled = createEvent(this, "toggled", 7);
    this.handleDocumentClick = (event) => {
      if (this.isExpanded) {
        const target = event.target;
        if (!this.el.contains(target)) {
          this.isExpanded = false;
          this.toggled.emit({ isExpanded: this.isExpanded });
          const dropdownMenu = this.el.querySelector('hmc-dropdown-menu');
          if (dropdownMenu) {
            dropdownMenu.isOpen = false;
          }
        }
      }
    };
    this.isDisabled = false;
    this.isLoading = false;
    this.kind = 'primary';
    this.isInverse = false;
    this.size = 'md';
    this.isExpanded = false;
  }
  connectedCallback() {
    document.addEventListener('click', this.handleDocumentClick);
  }
  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
  async toggleMenu() {
    if (!this.isDisabled) {
      this.isExpanded = !this.isExpanded;
      this.toggled.emit({ isExpanded: this.isExpanded });
    }
  }
  getRightIcon() {
    const expanded = this.isExpanded ? 'up' : 'down';
    const size = this.size === 'xs' ? 's' : 'm';
    return ('chevron-' + expanded + '-' + size);
  }
  render() {
    const { size, kind, isLoading, isDisabled, isInverse, isExpanded } = this;
    const classes = {
      'menu-button': true,
      'inverse': isInverse,
      'disabled': isDisabled,
      'expanded': isExpanded,
      [kind]: true,
    };
    return (h(Host, { role: "button", "aria-haspopup": "true", "aria-expanded": this.isExpanded.toString(), "aria-disabled": isDisabled.toString(), onClick: () => this.toggleMenu() }, h("div", { class: classes }, h("hmc-button", { size: size, kind: kind, isProcessing: isLoading, isDisabled: isDisabled, isInverse: isInverse }, h("slot", { slot: "icon-left", name: "icon-left" }), h("slot", null), h("hmc-icon", { class: "right-icon", slot: "icon-right", name: this.getRightIcon() })), h("div", { class: "menu-item" }, h("slot", { name: "menu" })))));
  }
  get el() { return this; }
  static get style() { return dropdownMenuButtonCss; }
}, [1, "hmc-dropdown-menu-button", {
    "isDisabled": [4, "disabled"],
    "isLoading": [4, "loading"],
    "kind": [1],
    "isInverse": [4, "inverse"],
    "size": [1],
    "isExpanded": [32],
    "toggleMenu": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["hmc-dropdown-menu-button", "hmc-button", "hmc-icon", "hmc-spinner"];
  components.forEach(tagName => { switch (tagName) {
    case "hmc-dropdown-menu-button":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, HmcDropdownMenuButton$1);
      }
      break;
    case "hmc-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "hmc-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "hmc-spinner":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const HmcDropdownMenuButton = HmcDropdownMenuButton$1;
const defineCustomElement = defineCustomElement$1;

export { HmcDropdownMenuButton, defineCustomElement };
